import axios from 'axios'

// 客服快捷语列表
export function customerShortcutLanguage (datas) {
  const url = `/customerShortcutLanguage`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 新增客服快捷语
export function addCustomerShortcutLanguage (datas) {
  const url = `/customerShortcutLanguage`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 编辑客服快捷语
export function editCustomerShortcutLanguage (datas) {
  const url = `/customerShortcutLanguage`
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 客服快捷语详情
export function queryCustomerShortcutLanguageById (datas) {
  const url = `/customerShortcutLanguage/queryCustomerShortcutLanguageById`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 导出客服快捷语列表
export function exportCustomerWorkOrderList (datas) {
  const url = `/customerShortcutLanguage/exportCustomerWorkOrderList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 删除客服快捷语
export function delCustomerShortcutLanguage (datas) {
  const url = `/customerShortcutLanguage/delCustomerShortcutLanguage`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 加载快捷语分类树
export function sysDictionary (datas) {
  const url = `/sysDictionary`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 快捷语分类保存
export function addSysDictionary (datas) {
  const url = `/sysDictionary/saveShortcutLanguageType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取快捷语分类列表
export function queryTypeList (datas) {
  const url = `/customerShortcutLanguage/queryTypeList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 删除快捷语分类
export function delShortcutLanguageType (datas) {
  const url = `/sysDictionary/delShortcutLanguageType`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/fast/index.js